var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOptions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_879",
    "data-name": "Group 879",
    transform: "translate(-2 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2399",
    "data-name": "Rectangle 2399",
    transform: "translate(2 -1)",
    fill: "#71207c",
    stroke: "#71207c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5230",
    "data-name": "Path 5230",
    d: "M24.341,15.091h-4.5a2.753,2.753,0,0,1-2.75-2.75v-4.5a2.753,2.753,0,0,1,2.75-2.75h4.5a2.753,2.753,0,0,1,2.75,2.75v4.5A2.753,2.753,0,0,1,24.341,15.091Zm-4.5-8.667a1.418,1.418,0,0,0-1.417,1.417v4.5a1.418,1.418,0,0,0,1.417,1.417h4.5a1.418,1.418,0,0,0,1.417-1.417v-4.5a1.418,1.418,0,0,0-1.417-1.417Z",
    transform: "translate(-4.091 3.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5231",
    "data-name": "Path 5231",
    d: "M36.242,15.091h-4.5a2.753,2.753,0,0,1-2.75-2.75v-4.5a2.753,2.753,0,0,1,2.75-2.75h4.5a2.753,2.753,0,0,1,2.75,2.75v4.5A2.753,2.753,0,0,1,36.242,15.091Zm-4.5-8.667a1.418,1.418,0,0,0-1.417,1.417v4.5a1.418,1.418,0,0,0,1.417,1.417h4.5a1.418,1.418,0,0,0,1.417-1.417v-4.5a1.418,1.418,0,0,0-1.417-1.417Z",
    transform: "translate(-3.992 3.909)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5233",
    "data-name": "Path 5233",
    d: "M24.341,26.992h-4.5a2.753,2.753,0,0,1-2.75-2.75v-4.5a2.753,2.753,0,0,1,2.75-2.75h4.5a2.753,2.753,0,0,1,2.75,2.75v4.5A2.753,2.753,0,0,1,24.341,26.992Zm-4.5-8.667a1.418,1.418,0,0,0-1.417,1.417v4.5a1.418,1.418,0,0,0,1.417,1.417h4.5a1.418,1.418,0,0,0,1.417-1.417v-4.5a1.418,1.418,0,0,0-1.417-1.417Z",
    transform: "translate(-4.091 6.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2400",
    "data-name": "Rectangle 2400",
    transform: "translate(29 23)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 10,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 9,
    rx: 0.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2401",
    "data-name": "Rectangle 2401",
    transform: "translate(35 27) rotate(90)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 10,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 9,
    rx: 0.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOptions);
export default __webpack_public_path__ + "static/media/icon_options.a1c5e8c377dc350e27d639c95e9c3c19.svg";
export { ForwardRef as ReactComponent };